
const promisesMap = {}


export function loadFile(url: string)
{
	if (promisesMap[url])
		return promisesMap[url];

	let isjs = url.endsWith("js");
	let nodes = document.querySelectorAll(isjs ? 'script' : 'link');
	let urlToLoad = url.startsWith('http') ? url : `/static/${url}`;

	for (let c = 0; c < nodes.length; c++)
	{
		if (nodes[c].getAttribute(isjs ? "src" : 'href') === urlToLoad)
			return new Promise(resolve => resolve(null));
	}

	return promisesMap[url] = new Promise((resolve, reject) =>
	{
		let tag = document.createElement(isjs ? 'script' : 'link') as any;
		tag.type = isjs ? 'text/javascript' : 'text/css';
		if (isjs)
			tag.src = urlToLoad
		else
		{
			tag.rel = "stylesheet";
			tag.href = urlToLoad
		}
		tag.addEventListener('load', () =>
		{
			delete promisesMap[url];
			resolve(null);
		}, false);
		tag.addEventListener('error', () => () =>
		{
			delete promisesMap[url];
			reject();
		}, false);
		document.head.appendChild(tag);
	});
}

export function loadFiles(urls: string[])
{
	return Promise.all(urls.map(url => loadFile(url)));
}